var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/submissions/components/SubmissionForm/SubmissionFormUploadClip.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/submissions/components/SubmissionForm/SubmissionFormUploadClip.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
var macro_t_4 = runtime.makeMacro(
[], 
["data", "ind"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});frame.set("ind", Object.prototype.hasOwnProperty.call(kwargs, "ind") ? kwargs["ind"] : 3);var t_5 = "";t_5 += "\n    <div class=\"SubmissionFormUploadClip\">\n\n        <div class=\"SubmissionFormUploadClip-order\">";
t_5 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "ind"), env.opts.autoescape);
t_5 += "</div>\n        <div class=\"SubmissionFormUploadClip-description TextFormatting\">\n            <h3>Embed Video Clip</h3>\n            <p>• Create an MP4 clip of max 60 seconds</p>\n            <p>• Name it your project’s title (example: Lincoln.mp4)</p>\n            <p>• Upload your clip to the ADG Vimeo Page using the following credentials:</p>\n            <p></p>\n            <p><b>URL:</b><a href=\"https://vimeo.com/log_in\">vimeo.com/log_in</a></p>\n            <p><b>E-mail Address:</b>adgawards@gmail.com</p>\n            <p><b>Password:</b>adgawards</p>\n            <p></p>\n            <p>• Once it’s uploaded, click on “Go To Video”, and copy paste the entire URL:</p>\n        </div>\n\n        <div class=\"SubmissionFormUploadClip-media ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"assetsVideoCode")) {
t_5 += "SubmissionFormUploadClip-media--hasMedia";
;
}
t_5 += "\">\n            <input type=\"text\" name=\"assetsVideoUrl\" class=\"SubmissionFormUploadClip-input\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"assetsVideoUrl")) {
t_5 += " value=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"assetsVideoUrl"), env.opts.autoescape);
t_5 += "\"";
;
}
t_5 += " ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"assetsVideoCode")) {
t_5 += " data-code=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"assetsVideoCode"), env.opts.autoescape);
t_5 += "\"";
;
}
t_5 += " data-provider=\"vimeo\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"assetsVideoCover")) {
t_5 += " data-cover=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"assetsVideoCover"), env.opts.autoescape);
t_5 += "\"";
;
}
t_5 += ">\n            <div class=\"SubmissionFormUploadClip-preview\">Preview</div>\n            <div class=\"SubmissionFormUploadClip-embed\">\n                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"assetsVideoCode")) {
t_5 += "\n                    ";
t_5 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"assetsVideoCode")), env.opts.autoescape);
t_5 += "\n                ";
;
}
t_5 += "\n            </div>\n        </div>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_5);
});
context.addExport("SubmissionFormUploadClip");
context.setVariable("SubmissionFormUploadClip", macro_t_4);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/submissions/components/SubmissionForm/SubmissionFormUploadClip.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/components/SubmissionForm/SubmissionFormUploadClip.jinja
// module id = 63
// module chunks = 0